var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrown3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0436 16.9453L5.00687 10.6142C4.92904 10.1388 5.52972 9.81617 5.95928 10.1025L9.50653 12.4653C9.78093 12.6481 10.1701 12.589 10.3617 12.3349L13.4968 8.18197C13.7373 7.86383 14.2606 7.86697 14.4956 8.18825L17.5839 12.4017C17.777 12.6651 18.1796 12.7243 18.456 12.5298L22.0282 10.0178C22.4577 9.71579 23.0774 10.0429 22.992 10.5273L21.859 16.9453H6.0436Z",
    fill: "#FDBA74"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18.9453H22V21.03C22 21.5355 21.6323 21.9453 21.1787 21.9453H6.82133C6.36775 21.9453 6 21.5355 6 21.03V18.9453Z",
    fill: "#FDBA74"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown3);
export default __webpack_public_path__ + "static/media/crown_3.d7fd2ae7cb87cba0983274b24e974661.svg";
export { ForwardRef as ReactComponent };